import React from 'react';
import {Button} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import {BrandTitle, HeaderWrapper, LogoBox} from './styles';
import {useLandingContext} from "../../../Landing";

export default function Header({onOpenTrial}) {
    const {APP_DATA} = useLandingContext();
    return (
        <HeaderWrapper>
            <LogoBox>
                <AutoAwesomeIcon color="primary" sx={{fontSize: 26}}/>
                <BrandTitle>{APP_DATA.brandName}</BrandTitle>
            </LogoBox>
            <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={onOpenTrial}
                style={{
                    borderRadius: 20,
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '13px',
                    padding: '6px 14px',
                    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.25)',
                }}
            >
                {APP_DATA.brandBadge}
            </Button>
        </HeaderWrapper>
    );
}
